
import { motion, AnimatePresence, useInView } from "framer-motion";
import { useEffect, useState, useRef } from "react";

const testimonials = [
  {
    quote: "Selah doesn't offer artificial spirituality, it delivers Biblical truth through modern means.",
    author: "Brent",
    title: "Selah Beta Tester"
  },
  {
    quote: "Truth doesn't change because technology does. The gospel remains, Selah is just a new way to carry it.",
    author: "Mike",
    title: "Youth Pastor"
  },
  {
    quote: "In a world trained by algorithms, we're training disciples.",
    author: "Nicholas Patrick",
    title: "Selah Founder"
  }
];

const RotatingTestimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const containerRef = useRef(null);
  const isInView = useInView(containerRef, {
    once: true,
    margin: "0px 0px -200px 0px"
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 7000);

    return () => clearInterval(timer);
  }, []);

  return (
    <motion.div 
      ref={containerRef}
      initial={{ opacity: 0, y: 50 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="relative h-[200px] md:h-[250px] flex items-center justify-center pb-8 md:pb-12"
    >
      <AnimatePresence mode="wait">
        <motion.div
          key={currentIndex}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.8, ease: "easeInOut" }}
          className="absolute w-full space-y-6"
        >
          
          <svg 
            className="mx-auto w-16 h-16 text-heaven-gold/20" 
            fill="currentColor" 
            viewBox="0 0 24 24"
          >
            <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
          </svg>
          <p className="text-2xl md:text-3xl font-playfair text-gray-800 leading-relaxed italic max-w-2xl mx-auto">
            "{testimonials[currentIndex].quote}"
          </p>
          <div className="text-heaven-gold font-medium">
            <span className="block">— {testimonials[currentIndex].author}</span>
            <span className="text-sm text-gray-600">{testimonials[currentIndex].title}</span>
          </div>
        </motion.div>
      </AnimatePresence>
    </motion.div>
  );
};

export default RotatingTestimonials;
